import { CashIcon, ClockIcon, ReceiptRefundIcon } from '@heroicons/react/outline';
import { TuitionReimbursementGrant } from 'interfaces/tuitionReimbursementInterfaces';

import React from 'react';
import { Link } from 'react-router-dom';
import { formatMoney } from 'utils/numberFormatter';

interface ParticipantTuitionReimbursementPlanElementProps {
  tuitionReimbursementGrant: TuitionReimbursementGrant;
}

const ParticipantTuitionReimbursementPlanElement: React.FC<ParticipantTuitionReimbursementPlanElementProps> = ({
  tuitionReimbursementGrant,
}) => {
  const participantPlan = tuitionReimbursementGrant.tuitionReimbursementPlan;

  let annualReimbursementMax = Number(tuitionReimbursementGrant.annualReimbursementMax).toFixed(2);

  const cards = [
    {
      name: 'Annual reimbursement max',
      href: '#',
      icon: CashIcon,
      amount: formatMoney(Number(annualReimbursementMax)),
    },
    { name: 'Credit hours max', href: '#', icon: ClockIcon, amount: Number(participantPlan?.creditHourMax) },
    {
      name: 'Submitted requests',
      href: '#',
      icon: ReceiptRefundIcon,
      amount: Number(tuitionReimbursementGrant._count?.tuitionReimbursementRequests),
    },

    // {
    //   name: 'Next election deadline',
    //   href: '#',
    //   icon: CalendarIcon,
    //   amount: participantPlan?.nextElectionDeadline ? abbrevDate(participantPlan.nextElectionDeadline) : 'Pending...',
    // },

    // More items...
  ];

  return (
    <>
      <div className="px-8 py-6 ring-1 ring-black ring-opacity-10 rounded">
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="flex-auto">
            <h1 className="text-xl font-bold text-gray-900">{participantPlan?.name}</h1>
          </div>

          <Link
            to={`/tuition-reimbursement/grants/${tuitionReimbursementGrant.id}/requests`}
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 w-full sm:w-auto my-2 sm:my-0"
          >
            Manage reimbursement requests
          </Link>
        </div>

        <div className="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {/* Card */}
          {cards.map((card) => (
            <div
              key={card.name}
              className="bg-white ring-1 ring-black ring-opacity-5 overflow-hidden shadow-md rounded-md"
            >
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <card.icon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">{card.name}</dt>
                      <dd>
                        <div className="text-lg font-medium text-gray-900">{card.amount}</div>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ParticipantTuitionReimbursementPlanElement;
